import createReactClass from 'create-react-class';
import PropTypes from 'prop-types';
import { findDOMNode } from 'react-dom';
import PureRenderMixin from './external-adapters/pureRenderMixinAdapter.js';
import { isState, getStateCode, isCity, getCityName, getCountyName, getLatLng, isCounty, getZip } from './placesUtils.js';
import { DropdownMixin } from './dropdownMixin.js';
import { getLocationText, getEmptyLocationParams, getBaseLocationParams, extractSuggestionLocationParameters, makeSuggestionName } from './locationUtils.js';
import './external-adapters/typeaheadJqueryAdapter.js';
import { locationBloodhound } from './locationBloodhound.js';
import { isValidZip } from '../../require/utils/addressUtils.ts';

// defined in general/_misc.js
/* global google, dcAnalytics */

// TODO: Refactor to separate reusable typeahead search from search-page-specific stuff?
export const LocationSearchBox = createReactClass({
    propTypes: {
        searchURL: PropTypes.string.isRequired,
        callbacks: PropTypes.object.isRequired,

        detectedLocation: PropTypes.object,
        projects: PropTypes.object,
        registerSearchCallback: PropTypes.func,
        searchAll: PropTypes.func,
        makeKeywordsURL: PropTypes.func,
        directlyUpdateText: PropTypes.bool,
    },

    mixins: [DropdownMixin, PureRenderMixin],
    locationBloodhound: null,
    searchName: 'location',
    selectedSuggestion: null,
    placeDetailFields: ['address_component', 'adr_address', 'alt_id', 'formatted_address', 'geometry', 'icon', 'name', 'photo', 'place_id', 'plus_code', 'scope', 'type', 'url', 'vicinity'],

    getInitialState: function () {
        return {
            keywords: getLocationText(this.props.searchURL),
        };
    },

    getInputElem: function () {
        return $(findDOMNode(this.refs.input));
    },

    clearLocationSearchBox: function () {
        this.setState({
            keywords: '',
        });
    },

    updateHasInput: function () {
        const hasInput = this.state.keywords && this.state.keywords.length > 0;
        if (this.props.callbacks.setAllowLocationSearchSubmit) {
            this.props.callbacks.setAllowLocationSearchSubmit(!!hasInput);
        }
    },

    UNSAFE_componentWillReceiveProps: function (newProps) {
        var keywords = getLocationText(newProps.searchURL);
        if (keywords !== getLocationText(this.props.searchURL)) {
            this.setState({
                keywords: keywords,
            });
        }
        this.getInputElem().typeahead('close');
    },

    componentDidUpdate: function () {
        if (this.props.callbacks.setAllowLocationSearchSubmit) {
            this.updateHasInput();
        }
    },

    componentDidMount: function () {
        this.locationBloodhound = locationBloodhound.make();

        this.getInputElem().typeahead({
            highlight: true,
            hint: false,
        }, {
            name: 'locations',
            source: this.locationBloodhound.ttAdapter(),
            displayKey: 'name',
            templates: {
                suggestion: function (location) {
                    return "<div class='suggestion location-suggestion'>" + location.name + '</div>';
                },
                empty: "<div class='no-suggestions'>No suggestions</div><a class='suggestion location-suggestion tt-suggestion tt-selectable map-suggestion' href='/donors/map.html'>View map of local classroom projects</a>",
                footer: "<a class='suggestion location-suggestion tt-suggestion tt-selectable map-suggestion' href='/donors/map.html'>View map of local classroom projects</a><div class='powered-by'>powered by<img src='" + baseCacheURL +
                    "images/powered-by-google/google_on_white_hdpi.png'" +
                    " alt='Powered by Google' /></div>",
            },
        }).on('typeahead:selected', function (event, suggestion, dataName) {
            this.selectedSuggestion = suggestion;
            this.search();
        }.bind(this)).keypress(function (e) {
            if (e.keyCode === 13) {
                this.search();
            }
        }.bind(this));

        // this is a hack, but React is turning autoComplete="new-password" into autocomplete="off" (off is no longer recognized by most browsers)
        $(findDOMNode(this.refs.input)).attr('autocomplete', 'new-password');
    },

    componentWillUnmount: function () {
        this.getInputElem().typeahead('destroy');
    },

    search: function () {
        (this.props.searchAll || this.submit)();
    },

    /**
     * Searches for the selected location
     * @param {string} searchURL The search URL to use (it may have had keywords added, meaning it wouldn't match props.searchURL)
     */
    submit: function (searchURL) {
        this.getInputElem().blur();
        searchURL = searchURL || this.props.searchURL;

        if (this.selectedSuggestion) {
            this.setLocation(searchURL, this.selectedSuggestion);
            this.selectedSuggestion = null;
            return;
        }

        var callbacks = this.props.callbacks;
        var keywords = this.state.keywords;

        if (keywords === getLocationText(this.props.searchURL)) {
            callbacks.changeURL(searchURL);
            return;
        }
        if (keywords === '') {
            var newURL = callbacks.makeSearchURL(getEmptyLocationParams(), searchURL);
            callbacks.changeURL(newURL);
        } else {
            this.locationBloodhound.search(keywords, function (locations) {
                // Use the first available suggestion, if it exists
                if (locations && locations.length > 0) {
                    this.setLocation(searchURL, locations[0]);
                } else {
                    callbacks.changeURL(searchURL);
                }
            }.bind(this));
        }
    },

    setLocation: function (searchURL, prediction) {
        if (!this.placesService) {
            this.placesService = new google.maps.places.PlacesService(document.createElement('div'));
        }

        var name = prediction.name;

        if (this.props.directlyUpdateText && name) {
            this.setState({
                keywords: name,
            });
        }

        this.placesService.getDetails({
            placeId: prediction.place_id,
            fields: this.placeDetailFields,
        }, function (place) {
            var params = getBaseLocationParams();

            if (isState(place)) {
                params.state = getStateCode(place);
                params.includeNearbyLocations = null;
                dcAnalytics.trackPageViewGA([pageName, 'state selected', params.state]);
            } else if (isCity(place)) {
                params.state = getStateCode(place);
                params.cityName = getCityName(place);
                params.countyName = getCountyName(place);
                var latLng = getLatLng(place);
                params.centerLat = latLng.lat;
                params.centerLng = latLng.lng;

                dcAnalytics.trackPageViewGA([pageName, 'city selected', params.cityName + ', ' + params.state]);
            } else if (isCounty(place)) {
                params.state = getStateCode(place);
                params.countyName = getCountyName(place);
                var latLng = getLatLng(place);
                params.centerLat = latLng.lat;
                params.centerLng = latLng.lng;

                dcAnalytics.trackPageViewGA([pageName, 'county selected', params.countyName + ', ' + params.state]);
            } else { // zip
                var latLng = getLatLng(place);
                params.centerLat = latLng.lat;
                params.centerLng = latLng.lng;
                params.centerZip = getZip(place);
                params.locationName = name;

                dcAnalytics.trackPageViewGA([pageName, 'zip selected', params.centerZip]);
            }

            this.close();
            var newURL = this.props.callbacks.makeSearchURL(params, searchURL);
            this.props.callbacks.changeURL(newURL);
        }.bind(this));

        dcAnalytics.track('Location Selected', { name: name });
    },

    handleChange: function (event) {
        this.setState({
            keywords: event.target.value.replace(/^\s+/, ''),
        }, this.handleDefaultSuggestions);
    },

    handleDefaultSuggestions: function () {
        this.toggleOpen(this.state.keywords === '');
    },

    selectDefaultLocation: function (event) {
        this.close();

        var props = this.props;
        var url = props.makeKeywordsURL ? props.makeKeywordsURL() : props.searchURL;
        var newURL = this.makeSuggestionURL(url);

        dcAnalytics.trackPageViewGA([pageName, 'detected location selected', newURL]);
        this.props.callbacks.changeURL(newURL);

        event.preventDefault();
    },

    /**
     * @param {string} [searchURL] Override search URL
     * @return {string} Search URL for the detected location
     */
    makeSuggestionURL: function (searchURL) {
        var props = this.props;
        var params = extractSuggestionLocationParameters(props.detectedLocation);
        return props.callbacks.makeSearchURL(params, searchURL);
    },

    render: function () {
        var props = this.props;

        if (props.projects && props.projects.breadcrumb) {
            // We let the legacy zip sort hide the new location selector
            var isLocationSort = props.projects.breadcrumb.some(function (crumb) {
                return crumb[0] === 'keywords' && isValidZip(crumb[1]);
            });
            if (isLocationSort) {
                var hiddenStyle = {
                    display: 'none',
                };
            }
        }

        var displaySuggestions = {
            display: 'none',
        };

        if (props.detectedLocation && this.state.keywords === '') {
            var suggestionName = makeSuggestionName(props.detectedLocation);
            var suggestionURL = this.makeSuggestionURL();

            if (this.state.isOpen) {
                displaySuggestions = {
                    display: 'block',
                };
            }
        }

        return (
            <span style={hiddenStyle}>
                <span className="search-string">near</span>
                <span className="location-holder">
                    <input className="location-search"  type="text" name="location"
                        placeholder="city, state, or zip"
                        ref="input"
                        value={this.state.keywords} onChange={this.handleChange}
                        onClick={this.handleDefaultSuggestions}
                        onFocus={this.handleDefaultSuggestions}
                        aria-label="Location search: suggestions appear below" />
                    <div className="subnav location-geosuggestion" style={displaySuggestions}>
                        <ul>
                            <li>
                                <a href={suggestionURL} onClick={this.selectDefaultLocation}>
                                    <span className="suggestion-label">Find classroom projects near you</span>
                                    {suggestionName}
                                </a>
                            </li>
                            <li>
                                <a href={`${baseURL}donors/map.html`}>
                                    <span className="suggestion-label">Explore your local area</span>
                                    View map
                                </a>
                            </li>
                        </ul>
                    </div>
                </span>
            </span>
        );
    },
});
